import { mainStore } from '~/stores';

import { TIMEOUT_STORAGE_KEY } from './constants';
import { TimeoutData } from './interfaces';

export const getTimeoutData = (): TimeoutData | null => {
  try {
    const data = localStorage.getItem(TIMEOUT_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setTimeoutData = (timeout: number): void => {
  try {
    const data: TimeoutData = {
      timestamp: Date.now(),
      timeout,
    };
    localStorage.setItem(TIMEOUT_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore localStorage
  }
};

export const clearTimeoutData = (): void => {
  try {
    localStorage.removeItem(TIMEOUT_STORAGE_KEY);
  } catch {
    // ignore localStorage
  }
};

export const getRemainingTime = (): number => {
  const data = getTimeoutData();
  if (!data) {
    return 0;
  }

  const elapsed = Date.now() - data.timestamp;
  const remaining = data.timeout - elapsed;
  return Math.max(0, remaining);
};

export const formatTime = (
  milliseconds: number,
  opts?: { secondsLabel?: string; minutesLabel?: string },
): string => {
  const { secondsLabel, minutesLabel } = opts || {};
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes === 0) {
    return secondsLabel
      ? `${seconds.toString()} ${secondsLabel}`
      : seconds.toString();
  }

  const result = `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;

  return minutesLabel ? `${result} ${minutesLabel}` : result;
};

/**
 * Checks if the phone number is a test number that should have OTP enabled
 * Test numbers: +0 or 0 prefix (dev/testing/staging only), +440000000000 (all envs)
 */
export const isTestPhoneNumber = (phoneNumber: string): boolean => {
  const normalizedPhone = phoneNumber.replace(/\s/g, '');
  const isProduction = mainStore.environment === 'production';

  if (
    normalizedPhone === '+440000000000' ||
    normalizedPhone === '440000000000'
  ) {
    return true;
  }

  if (!isProduction) {
    if (normalizedPhone.startsWith('+0') || normalizedPhone.startsWith('0')) {
      return true;
    }
  }

  return false;
};
